import { useTheme, getColorVisionStylesForActiveIndex } from '@shopify/polaris-viz-core';
import { PREVIEW_ICON_SIZE } from '../../../../constants.js';
import { TITLE_MARGIN } from '../../constants.js';
import styles from './TooltipRow.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SeriesIcon } from '../../../shared/SeriesIcon/SeriesIcon.js';

function TooltipRow({
  activeIndex,
  color,
  index,
  isComparison = false,
  isHidden = false,
  label,
  renderSeriesIcon,
  shape,
  value
}) {
  var _renderSeriesIcon;

  const selectedTheme = useTheme();

  if (isHidden) {
    return null;
  }

  return /*#__PURE__*/jsxs("div", {
    className: styles.Row,
    style: getColorVisionStylesForActiveIndex({
      activeIndex,
      index
    }),
    children: [color != null && /*#__PURE__*/jsx("div", {
      style: {
        width: PREVIEW_ICON_SIZE
      },
      children: (_renderSeriesIcon = renderSeriesIcon === null || renderSeriesIcon === void 0 ? void 0 : renderSeriesIcon()) !== null && _renderSeriesIcon !== void 0 ? _renderSeriesIcon : /*#__PURE__*/jsx(SeriesIcon, {
        color: color,
        isComparison: isComparison,
        shape: shape
      })
    }), /*#__PURE__*/jsx("span", {
      className: styles.Truncate,
      style: {
        color: selectedTheme.tooltip.textColor,
        marginRight: TITLE_MARGIN
      },
      children: label
    }), /*#__PURE__*/jsx("span", {
      className: styles.Value,
      style: {
        color: selectedTheme.tooltip.textColor
      },
      children: value
    })]
  });
}

export { TooltipRow };
